import React from 'react'
import { Link } from 'react-router-dom'
import './components.css'

const LoginButtonComponent = ({ isLogin, onClickLogout, location }) => {
    return isLogin ? (
        <button
            onClick={onClickLogout}
            className="btn btn-outline-secondary rounded-pill px-3 mb-2 mb-lg-0"
        >
            로그아웃
        </button>
    ) : (
        <Link
            to={'/login'}
            replace={true}
            state={{ from: location }}
            className="btn btn-outline-secondary rounded-pill px-3 mb-2 mb-lg-0"
        >
            로그인
        </Link>
    )
}



export default LoginButtonComponent